
abstract class BaseModel {
    constructor() {}
    clone() : this{
        return new (<any>this.constructor)(JSON.parse(JSON.stringify(this)));
    }   
}  

export default BaseModel;
  